/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ImageSparkleIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7UlEQVR4nM1Vv2sUURDemKgh8ToR7Q3CYaVYLwgHh9mZNy/h3czqwZIiZyHY+Adc6Ym9pX3yB6h/RBKbS8BKCyOCraYJiTJ3t3t7m929Xykc+OCxb2a+mW9mdz3vEsw5dwOI9xR69i7bkGQbSf4qgLhVVMU1JH4Dhn/Ezvng34FtPIjj/ChaBpLDIYEc1uv163lVdMoTSx9WXvT8EStaLRg5yimi2+sKsZIQAPFx2kk7AcNnAyRdWdu8NfD/PK4YID5Id5C6kK++7y8BuLuKVqt1FQ1/07snzt2emwAN71yQ0PDOQKKXsUQqQ1r/9BxUvhGJhsnlgw4uS+BH0TIa/ghGToAk9DxvIRnyyBy4WzTksQRA/Gk4I/kCxBt6Z0z4PNXBdu6ajpdIdi9IYeQotVEHihFZigh0yDrY9Y1wTZEechaBCTezuYiePizvoK/lz3hN9Vz24um7EQThTWuf3dGzPpuAoABG9nsbQvIWSU6L/GYk4G6t1lyNY4AkmpfgHEn+JFKgq2bjgOT9jAT8a9027jvnFtHIO602bzmCIFgZfHumIjgFK4/ju3a7fSUveRKLrtrrcFICMPKqLGGeITa2JiYIbOORN6UhunulBNnP9Zz4PvsPh8YDjLwu+GVKZ55OoB/b0VzTSvz/2j9UQFn/GR00yQAAAABJRU5ErkJggg==)
 */
export const ImageSparkleIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M20.14.8a1.21 1.21 0 0 0-2.28 0l-.5 1.37a2 2 0 0 1-1.19 1.18l-1.38.51a1.21 1.21 0 0 0 0 2.28l1.38.5a2 2 0 0 1 1.18 1.19l.51 1.38a1.21 1.21 0 0 0 2.28 0l.5-1.38a2 2 0 0 1 1.19-1.18l1.38-.51a1.21 1.21 0 0 0 0-2.28l-1.38-.5a2 2 0 0 1-1.18-1.19L20.14.79Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M13.25 2c.17 0 .23.28.1.38A3.22 3.22 0 0 0 14.1 8l1.38.51.5 1.38a3.22 3.22 0 0 0 5.64.76c.1-.14.38-.08.38.09V19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h8.25Zm2.1 11.13 3.5 4.67c.37.5.02 1.2-.6 1.2H5.81a.75.75 0 0 1-.59-1.22l1.86-2.32a1.5 1.5 0 0 1 2.34 0l.5.64 2.23-2.97a2 2 0 0 1 3.2 0ZM10.2 5.98c.23-.91-.88-1.55-1.55-.9a.93.93 0 0 1-1.3 0c-.67-.65-1.78-.01-1.55.9a.93.93 0 0 1-.65 1.12c-.9.26-.9 1.54 0 1.8.48.14.77.63.65 1.12-.23.91.88 1.55 1.55.9a.93.93 0 0 1 1.3 0c.67.65 1.78.01 1.55-.9a.93.93 0 0 1 .65-1.12c.9-.26.9-1.54 0-1.8a.93.93 0 0 1-.65-1.12Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
